<template>
  <v-app id="inspire">
    <router-view name="headerAndMenu" />
    <v-main class="main">
      <v-container padding="20px">
        <router-view />
      </v-container>
    </v-main>
    <v-dialog
      name="dialogMessage"
      :value="getDialog('generalDialog')"
      width="500px"
      @input="handleDialogInput"
    >
      <v-card>
        <v-card-title>{{ dialogType }}</v-card-title>
        <v-container class="px-6">{{ dialogMessage }}</v-container>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="handleCancel">Tamam</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
export default {
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
  }),
  computed: {},
  methods: {
    loadInitialDatas() {},
    handleDialogInput(e) {
      this.setDialog({ dialogName: "generalDialog", status: e });
    },
    handleCancel() {
      this.setDialog({ dialogName: "generalDialog", status: false });
    },
  },
  created() {
    this.loadInitialDatas();
  },
};
</script>

<style lang="scss">
.disable-events {
  pointer-events: none;
}

.header {
  background: black;
}
.main {
  background-color: $gradient-white !important;
}
</style>
